import {
    PieChart,
    Pie,
    Tooltip,
    Cell,
    Legend,
    ResponsiveContainer
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { groupColors, legendHeight, legendIconSize, outerRadius, responsiveContainerHeight } from '../constants/graph-constants';
import { CustomLegend, PieTooltip, renderCustomizedLabel } from '../utils/graph-utils';

const GroupPieChart = ({ data, type, year, companyName, unit }) => {
    // Filter out entries with value 0
    const filteredData = data?.filter(entry => entry.value > 0) || [];
    const sortedFilteredData = filteredData?.slice().sort((a, b) => a?.name?.localeCompare(b?.name))
    // const combinedPieSlices = combineSmallPieSlices(sortedFilteredData, 'group')
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {companyName} {year} Annual {type} Group Split
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <PieChart>
                    <Tooltip content={<PieTooltip unit={unit} />} />
                    <Legend content={<CustomLegend variant={'group'} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    <Pie
                        data={sortedFilteredData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={outerRadius}
                        labelLine={false}
                        label={renderCustomizedLabel}
                    >
                        {sortedFilteredData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={
                                    groupColors[entry.name] || '#ccc'
                                }
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default GroupPieChart;